module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/15-8e4fa2b9e8e60f566d721b9d1ef1d44e.webm";